import _taggedTemplateLiteral from "/Users/diego.sampaio/olx/connecting/chat-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import styled from 'styled-components';
import { withMargins } from '../../mixins';
export const DividerWrapper = styled.hr(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 0;\n  height: 1px;\n  border: none;\n  background-color: ", ";\n  ", "\n"])), _ref => {
  let {
    inverted = false
  } = _ref;
  return inverted ? 'var(--divider-inverted-background-color)' : 'var(--divider-default-background-color)';
}, withMargins);